import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // bootstrap i18next before any component mounts
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker (production only — dev avoids cache thrash)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => { /* ignore */ });
  });
}
